import { EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS } from "@academy-context/shared/domain/types/enums/external-provider-batch-request";

export type Phase = "review" | "pending_validation" | "training_in_progress" | "invoice_editable" | "invoice_readonly";

export const getPhaseFromStatus = (status: EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS): Phase => {
  switch (status) {
    // Review Phase: Provider can edit request data
    case EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.REQUEST_PENDING_PROVIDER_VERIFICATION:
    case EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.REQUEST_REFUSED:
      return "review";

    // Pending Validation Phase: Request submitted, waiting for admin
    case EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.REQUEST_TO_VALIDATE:
      return "pending_validation";

    // Training In Progress Phase: Batch is scheduled or running
    case EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.REQUEST_APPROVED:
    case EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.SCHEDULED:
    case EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.RUNNING:
      return "training_in_progress";

    // Invoice Editable Phase: Provider can submit/edit invoice
    case EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.WAITING_FOR_INVOICE:
    case EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.INVOICE_REFUSED:
      return "invoice_editable";

    // Invoice ReadOnly Phase: Invoice submitted and under review or paid
    case EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.INVOICE_TO_VALIDATE_BY_ADMIN:
    case EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.INVOICE_APPROVED:
    case EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.PAID:
      return "invoice_readonly";

    default: {
      const _exhaustiveCheck: never = status;
      throw new Error(`Unhandled status: ${_exhaustiveCheck}`);
    }
  }
};
